module.exports = __webpack_public_path__ + "img/JubileeFlyIn.2edb7bc.svg";